<template>
    <div id="customerServiceManage">
        <el-form ref="searchForm" :model="searchForm" style="width:100%" :inline="true" :label-position="labelPosition">
            <el-form-item style="margin-bottom:15px">
                <el-select filterable v-model="searchForm.customerServicesType" placeholder="请选择工程师类别"  clearable>
                    <el-option v-for="(item,index) in pickingStatusList" 
                        :label="item.paraName" 
                        :value="item.paraValue" 
                        :key="index">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item style="margin-bottom:15px">
                <el-select filterable v-model="searchForm.state" placeholder="请选择启用状态" clearable>
                    <el-option v-for="(item,index) in pickingStateList" 
                        :label="item.paraName" 
                        :value="item.paraCode" 
                        :key="index">
                    </el-option>
                </el-select>
            </el-form-item> 
            <el-form-item style="margin-bottom:15px">
                <el-select filterable clearable v-model="searchForm.staffName" placeholder="请选择客服">
                    <el-option v-for="(item,index) in pickingUserAllList" 
                        :label="item.staffName" 
                        :value="item.staffName" 
                        :key="index">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item style="margin-bottom:15px">
                <el-input clearable v-model.trim="searchForm.loginName" placeholder="请输入客服账号"></el-input>
            </el-form-item>
            <el-form-item style="margin-bottom: 15px;">
                <el-button type="primary" size="medium" @click="onSubmit">查询</el-button>
                <el-button type="text" @click="clearFrom()" style="width: 60px;color: #169BD5;">重置</el-button>
            </el-form-item>
            <el-form-item class="fr">
                <el-col style="text-align:right">
                    <el-button size="medium" v-if="basicsAuth.create_services" type="success" @click="createCustomer()">新建客服</el-button>
                    <el-button type="success" size="medium" @click="downLoad.exportExcel('tableId')">导出</el-button>
                    <i class="el-icon-refresh" style="font-size: 25px;cursor: pointer;margin-left: 30px;" @click="refresh()"></i>
                </el-col>
            </el-form-item>
        </el-form>
        <el-card class="box-card" style="width: 100%;">
            <el-table
                :data="returnData"
                border
                id="tableId"
                :header-cell-style="{'text-align':'center'}"
                style="width: 100%">
                <el-table-column
                    align="center"
                    prop="staffName"
                    label="客服姓名"
                    width="120">
                </el-table-column>
                <el-table-column
                    align="center"
                    prop="loginName"
                    label="客服账号">
                </el-table-column>
                <el-table-column
                    align="center"
                    prop="customerServicesType"
                    label="客服类别">
                    <template slot-scope="scope">
                        {{scope.row.customerServicesType | sysCodeFileter('customer_services_type')}}
                    </template>
                </el-table-column>
                <el-table-column
                    align="center"
                    label="是否自动接单">
                    <template  slot-scope="scope">
                        <span v-if="scope.row.automaticOrder == '1'">启用</span>
                        <span v-else>禁用</span>
                    </template>
                </el-table-column>
                <el-table-column
                    align="center"
                    prop="orderOnline"
                    label="接单上限数">
                </el-table-column>
                <el-table-column
                    align="center"
                    label="启用状态">
                    <template  slot-scope="scope">
                        <span v-if="scope.row.state == '1'">启用</span>
                        <span v-else>禁用</span>
                    </template>
                </el-table-column>
                <el-table-column
                    align="center"
                    label="操作"
                    width="60" v-if="basicsAuth.update_customer_services">
                    <template slot-scope="scope">
                        <el-button @click.stop="exitBtn(scope.$index, scope.row)" type="text" size="small">编辑</el-button>
                    </template>
                </el-table-column>
            </el-table>
             <!--分页-->
            <el-col :span="24" class="toolbar">
                <div class="pagination">
                    <el-pagination
                        background
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="pages.page"
                        :page-sizes="[10, 20, 50, 100]"
                        :page-size="pages.pageSize"
                        layout="total, sizes, prev, pager, next,jumper"
                        :total="pages.total">
                    </el-pagination>
                </div>
            </el-col>
            <el-dialog :title="textMenu[dialogMenuStatus]" :visible.sync="dislogCreate" :close-on-click-modal="false" width="600px" @close="emptyDialog('modelForm')">
                <el-form ref="modelForm" :model="modelForm" label-width="100px" :label-position="labelPosition" :rules="modelFormRules">
                    <el-form-item label="选择类型:"  prop="customerServicesType">
                        <el-select filterable clearable v-model="modelForm.customerServicesType" placeholder="请选择类型" style="width: 100%;">
                            <el-option v-for="(item,index) in pickingStatusList" 
                                :label="item.paraName" 
                                :value="item.paraValue" 
                                :key="index">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="选择客服:" prop="customerServicesId">
                        <el-select filterable clearable v-model="modelForm.customerServicesId" placeholder="请选择客服" style="width: 100%;">
                            <el-option v-for="(item,index) in pickingUserList" 
                                :label="item.staffName" 
                                :value="item.userId" 
                                :key="index">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="接单上限:" prop="orderOnline">
                        <el-input clearable v-model.trim="modelForm.orderOnline"></el-input>
                    </el-form-item>
                    <el-form-item label="是否自动接单:" prop="automaticOrder">
                        <el-switch v-model.trim="modelForm.automaticOrder" :active-value="1" :inactive-value="-1" ></el-switch>
                    </el-form-item>
                    <el-form-item label="启用状态：" prop="state">
                        <el-switch v-model="modelForm.state" :active-value="1" :inactive-value="-1" ></el-switch>
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button v-if="dialogMenuStatus=='create'" type="primary" @click="createData()">立即创建</el-button>
                    <el-button v-else type="primary" @click="updateData()">保存</el-button>
                    <el-button @click="emptyDialog('modelForm')">取消</el-button>
                </div>
            </el-dialog>
        </el-card>
    </div>
</template>
<script>
    import Vue from 'vue'
    import { selectParameterInfoBusiness,queryCustomerServices,createServices,queryUser,updateServices } from "../../api/api";
    import {getPermission} from '../../api/authRequest'
    export default {
        name: 'customerServiceManage',
        inject: ['reload'], 
        components: {
        },
        data () {
            const validateNumber = (rule, value, callback) => {
                if (/^100$|^(\d|[1-9]\d)$/.test(value) == false) {
                    callback(new Error("请输入一个大于0,小于100的整数"));
                }else {
                    callback();
                }
            }
            return {
                dialogMenuStatus: "",
                textMenu: {
                    update: "修改客服",
                    create: "新增客服"
                },
                pickingStatusList:[],
                pickingStateList:[
                    {
                        paraName:'启用',
                        paraCode:'1'
                    },
                    {
                        paraName:'禁用',
                        paraCode:'0'
                    }
                ],
                pickingUserList:[],
                pickingUserAllList:[],
                dislogCreate:false,
                labelPosition:'left',
                modelForm:{
                    customerServicesType: '',
                    customerServicesId: '',
                    orderOnline: '',
                    automaticOrder: 1,
                    state: 1,
                },
                modelFormRules:{//validateRoleName
                    customerServicesType: [{ required: true, message: "请选择类型", trigger: "blur" }],
                    customerServicesId: [{ required: true, message: "请选择客服", trigger: "blur" }],
                    orderOnline: [{ required: true, validator: validateNumber, trigger: 'blur' }],
                },
                //分页变量
                pages:{
                    total: 0,
                    page: 1,
                    pageSize: 10,
                },
                searchForm:{
                    staffName: '',
                    loginName: '',
                    customerServicesType:'',
                    state:''
                },
                returnData: [],
                basicsAuth:{
                    create_services:false,
                    update_customer_services:false
                }
            }
        },
        mounted () {
            this.basicsAuth.create_services = getPermission('/api/customer_services/create_services');
            this.basicsAuth.update_customer_services = getPermission('/api/customer_services/update_customer_services');
    
        },
        created(){
            this.queryUserAllList();
            this.getEnginnerStatusList(); //获取工程师类型
            this.getCustomerServiveList();//获取客服列表
        },
        methods: {
            //重置
            clearFrom(){
                Object.keys(this.searchForm).forEach(key => this.searchForm[key]= '');
                this.getCustomerServiveList();
            },
            //清空dialog
            emptyDialog(formName) {
                Object.keys(this.modelForm).forEach(key => this.modelForm[key]= '');
                this.$refs[formName].resetFields();
                this.dislogCreate = false;
            },
            //新建客服
            createCustomer() {
                this.dislogCreate = true;
                this.dialogMenuStatus = "create";
                Object.keys(this.modelForm).forEach(key => this.modelForm[key]= '');
                this.modelForm.automaticOrder = 1;
                this.modelForm.state = 1;
                this.queryUserList(1);
            },
            //刷新
            refresh() {
                Object.keys(this.searchForm).forEach(key => this.searchForm[key]= '');
                this.getCustomerServiveList();
            },
            //检索查询
            onSubmit() {
                this.getCustomerServiveList()
            },
            //修改门店
            exitBtn(index,item) {
                this.dislogCreate = true
                this.dialogMenuStatus = "update";
                this.modelForm = Object.assign({}, item);
                this.queryUserList(2);
            },
            handleSizeChange(val) {
                this.pages.pageSize = val
                this.getCustomerServiveList();
            },
            handleCurrentChange(Page) {
                this.pages.page = Page
                this.getCustomerServiveList();
            },
            //确认修改
            updateData(){
                this.modelForm.automaticOrder = this.modelForm.automaticOrder == -1 ? 0 : 1;
                this.modelForm.state = this.modelForm.state == -1 ? 0 : 1;
                updateServices(this.modelForm).then(res =>{
                    if(res.data.status == '100'){
                        if(res.data.results){
                            this.$message({
                                message: '修改成功',
                                type: "success"
                            });
                            this.getCustomerServiveList(); //刷新
                            this.emptyDialog('modelForm');
                        }
                    }else{
                        this.$message({
                            message: res.data.message,
                            type: "error"
                        });
                    }
                }).catch((error) =>{
                    this.$Message.error(error.message);
                })
            },
            //查询工程师类别
            getEnginnerStatusList(){
                selectParameterInfoBusiness({paraType:"customer_services_type"}).then(res =>{
                    if(res.data.status == '100'){
                        this.pickingStatusList = res.data.results.list
                    }else{
                        this.$message({
                            message: res.data.message,
                            type: "error"
                        });
                    }
                }).catch((error) =>{
                    this.$Message.error(error.message);
                })
            },
            //查询客服列表
            getCustomerServiveList(){
                this.searchForm.startRow = this.pages.page;
                this.searchForm.pageSize = this.pages.pageSize;
                queryCustomerServices(this.searchForm).then(res =>{
                    if(res.data.status == '100'){
                        this.returnData = res.data.results.list;
                        this.pages.total = res.data.results.total;
                        this.returnData.forEach((item,index)=>{
                            item.customerServicesType = item.customerServicesType.toString()
                        })
                    }else{
                        this.$message({
                            message: res.data.message,
                            type: "error"
                        });
                    }
                }).catch((error) =>{
                    this.$Message.error(error.message);
                })
            },
            //新建客服
            createData(){
                this.$refs['modelForm'].validate((valid) => {
                    if (valid) {
                        createServices(this.modelForm).then(res =>{
                            if(res.data.status == '100'){
                                if(res.data.results){
                                    this.$message({
                                        message: '新建成功',
                                        type: "success"
                                    });
                                    this.getCustomerServiveList(); //刷新
                                    this.emptyDialog('modelForm');
                                }
                            }else{
                                this.$message({
                                    message: res.data.message,
                                    type: "error"
                                });
                            }
                        }).catch((error) =>{
                            this.$Message.error(error.message);
                        })
                    }
                })
            },
            //查询客服账号
            queryUserList(type){
                let para = {
                    type:type
                }
                queryUser(para).then(res =>{
                    if(res.data.status == '100'){
                        this.pickingUserList = res.data.results
                    }else{
                        this.$message({
                            message: res.data.message,
                            type: "error"
                        });
                    }
                }).catch((error) =>{
                    this.$Message.error(error.message);
                })
            },
            //查询客服账号
            queryUserAllList(){
                queryUser({type:2}).then(res =>{
                    if(res.data.status == '100'){
                        this.pickingUserAllList = res.data.results
                    }else{
                        this.$message({
                            message: res.data.message,
                            type: "error"
                        });
                    }
                }).catch((error) =>{
                    this.$Message.error(error.message);
                })
            }
        },
        computed: {},
        watch: {}
    }
</script>

<style lang="scss" type="text/css" scoped>
    #customerServiceManage{
        font-size: 14px;
        .headerT{
            margin:8px 0 15px 0;
            width: 80px;
        }
    }  
</style>



// WEBPACK FOOTER //
// customerServiceManage.vue?2e2a3021